module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Epigraph-rw",
    attrs: {
      "epub:type": "bodymatter epigraph",
      "id": "Epigraph1"
    }
  }, [_c('div', {
    staticClass: "epigraph-rw",
    attrs: {
      "id": "epigraph1"
    }
  }, [_c('p', {
    staticClass: "ep1-rw",
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("Hush-a-by, don’t you cry, go to sleep, you little baby.")]), _vm._v(" "), _c('p', {
    staticClass: "ep-rw",
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("When you wake you shall have all the pretty little horses")]), _vm._v(" "), _c('p', {
    staticClass: "ep-rw",
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("Dapples and grays, pintos and bays,")]), _vm._v(" "), _c('p', {
    staticClass: "ep-rw",
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("All the pretty little horses.")])]), _vm._v(" "), _c('div', {
    staticClass: "leading-line-rw",
    attrs: {
      "id": "leading-line1"
    }
  }, [_c('p', {
    attrs: {
      "id": "p37"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "epigraph-rw",
    attrs: {
      "id": "epigraph2"
    }
  }, [_c('p', {
    staticClass: "ep1-rw",
    attrs: {
      "id": "p38"
    }
  }, [_vm._v("Hush-a-by, don’t you cry, go to sleep, you little baby.")]), _vm._v(" "), _c('p', {
    staticClass: "ep-rw",
    attrs: {
      "id": "p39"
    }
  }, [_vm._v("When you wake you shall have all the pretty little horses.")]), _vm._v(" "), _c('p', {
    staticClass: "source-rw",
    attrs: {
      "id": "source1"
    }
  }, [_vm._v("—traditional pre-Rising lullaby")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229e7843","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s005-Epigraph-001.vue
// module id = 72
// module chunks = 0